import { AppRoutePaths } from '@/routing/route_paths'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import IncomeAttestations from './attestations/IncomeAttestations'
import DWSIncomePage from './dws/Page'
import useTaxableIncomeDocumentParams from './hooks/useTaxableIncomeDocumentParams'
import { IncomeVerificationType } from './IncomeVerificationType'
import TaxCommissionVerificationPage from './tax_comission/TaxComissionVerificationPage'
import TaxCommissionConsentPage from './tax_comission/TaxCommissionCheckIncomePage'
import TaxCommissionSSNPage from './tax_comission/TaxCommissionSSNPage'

type CommissionStep =
  | 'tax-commission-consent'
  | 'tax-commission-check-income'
  | 'tax-commission-attestation'
  | 'income-verification-type'
  | 'tax-commission-ssn'
  | 'dws'
  | 'dws-success'

function IncomeVerificationPage() {
  const [step, setStep] = useState<CommissionStep>('dws')
  const { onEnterForm } = useTaxableIncomeDocumentParams()
  const navigate = useNavigate()

  function goToDocumentUploadPage() {
    onEnterForm(
      AppRoutePaths.family_application.income_verification
        .document_instructions,
      'form_1040'
    )
  }

  if (step === 'tax-commission-ssn') {
    return (
      <TaxCommissionSSNPage
        onAddSSNSuccess={() => {
          setStep('tax-commission-check-income')
        }}
        onSkipClick={() => {
          goToDocumentUploadPage()
        }}
      />
    )
  }

  if (step === 'income-verification-type') {
    return <IncomeVerificationType />
  }

  if (step === 'tax-commission-consent') {
    return (
      <TaxCommissionConsentPage
        onNoConsent={() => {
          goToDocumentUploadPage()
        }}
        onConsent={() => {
          setStep('tax-commission-check-income')
        }}
      />
    )
  }

  if (step === 'tax-commission-attestation') {
    return <IncomeAttestations />
  }

  if (step === 'tax-commission-check-income') {
    return (
      <TaxCommissionVerificationPage
        onValidationErrorContinueClick={() => {
          goToDocumentUploadPage()
        }}
        onInformationCorrect={() => {
          setStep('tax-commission-attestation')
        }}
        onInformationIncorrect={() => {
          goToDocumentUploadPage()
        }}
      />
    )
  }

  return (
    <DWSIncomePage
      onSkipClick={() => {
        goToDocumentUploadPage()
      }}
      onDwsFailed={() => {
        navigate(
          AppRoutePaths.family_application.income_verification
            .alternative_verification_method
        )
      }}
      onNotRecievingBenefitContinueClick={() => {
        navigate(
          AppRoutePaths.family_application.income_verification
            .alternative_verification_method
        )
      }}
      onRecievingBenfitContinueClick={async () => {

        navigate(
          AppRoutePaths.family_application.income_verification
            .success_verification
        )
      }}
    />
  )
}

export default IncomeVerificationPage
